import React from "react";
import { Medal, Shield, Home, Heart, HelpCircle, Check } from "lucide-react";
import { AUDIENCE, STEPS, ASSETS } from "../../mock";

const ICONS = { Medal, Shield, Home, Heart, HelpCircle };

const WhoSteps = () => {
  const scrollToForm = () => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });

  return (
    <>
      {/* [003] Who this is for */}
      <section className="py-28 border-t border-[#131c31]" data-testid="audience-section">
        <div className="max-w-7xl mx-auto px-6">
          <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-6 reveal">{AUDIENCE.label}</p>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-14 reveal" data-testid="audience-headline">
            {AUDIENCE.headline}
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3 reveal">
            {AUDIENCE.items.map((it) => {
              const Icon = ICONS[it.icon];
              return (
                <div key={it.text} className="card-hover border border-[#1c2740] bg-[#0c1324]/60 p-6 hover:border-[#3f639f]">
                  <Icon size={22} className="text-[#6b9be8] mb-5" />
                  <p className="text-[#c3cde2] text-sm leading-relaxed">{it.text}</p>
                </div>
              );
            })}
          </div>
          <button
            onClick={scrollToForm}
            data-testid="audience-cta"
            className="cta-glow mt-10 flex items-center gap-2 bg-[#3f639f] hover:bg-[#4f76b8] text-white font-mono text-xs tracking-[0.25em] uppercase px-8 py-4 reveal"
          >
            <Check size={15} /> Reserve My Free Seat
          </button>
        </div>
      </section>

      {/* Steps 01-04 */}
      <section className="relative py-24 border-t border-[#131c31] overflow-hidden" data-testid="steps-section">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-[0.1]"
          style={{ backgroundImage: `url(${ASSETS.blueprint})` }}
        />
        <div className="relative max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <div
              key={s.num}
              className={`card-hover relative p-8 lg:p-10 border-[#1c2740] ${i > 0 ? "lg:border-l" : ""} border-b lg:border-b-0 reveal`}
            >
              <span className="absolute top-2 right-4 font-heading text-[#131f3a] text-8xl select-none leading-none">{s.num}</span>
              <p className="relative font-mono text-[10px] tracking-[0.3em] text-[#6b9be8] uppercase mb-4">STEP {s.num}</p>
              <h3 className="relative font-heading uppercase text-white text-2xl tracking-tight mb-3">{s.title}</h3>
              <p className="relative text-[#8fa0c0] text-sm leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default WhoSteps;
